import {
  TAX_INVOICE_ALL,
  TAX_INVOICE_CREATE,
  TAX_INVOICE_DELETE,
  TAX_INVOICE_GET,
  TAX_INVOICE_UPDATE,
  TAX_INVOICE_ERROR,
} from "../../actions/types"

const initialState = {
  tax_invoice: null,
  isLoading: false,
}
export default function TaxInvoiceReducer(state = initialState, action) {
  switch (action.type) {
    case TAX_INVOICE_ALL:
      return {
        arr: action.payload?.rows,
        currPage: action.payload?.currPage,
        lastPage: action.payload?.lastPage,
        isLoading: true,
      }
    case TAX_INVOICE_GET:
      return {
        ...action.payload,
        isLoading: true,
      }
    case TAX_INVOICE_CREATE:
      return { isLoading: false }
    case TAX_INVOICE_UPDATE:
      return { isLoading: false }
    case TAX_INVOICE_DELETE:
      return { isLoading: false }
    case TAX_INVOICE_ERROR:
      return { isLoading: false }
    default:
      return state
  }
}
